<template>
  <div class="page">
    <h2 class="text-center text-primary">{{ textoDaSolicitacaoDeAcesso }}</h2>
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Nome"
              v-model="form.filters.nome"
              outlined
              dense
              @keyup.enter="buscarSolicitacoesDeAcesso"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              id="cpf"
              label="CPF"
              v-model="form.filters.cpf"
              v-mask="'###.###.###-##'"
              dense
              outlined
              hide-details="auto"
              maxlength="14"
              @keyup.enter="buscarSolicitacoesDeAcesso"
            />
          </v-col>
          <v-col cols="2">
              <v-select
                label="Situação"
                :items="form.lists.listSituacoes"
                :item-text="'descricao'"
                :item-value="'id'"
                v-model="form.filters.situacao"
                outlined
                dense
              ></v-select>
            </v-col>
        </v-row>
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-autocomplete
              id="lotacao"
              label="Lotação"
              :items="form.lists.listLotacao"
              :item-text="'nome'"
              :item-value="'id'"
              v-model="form.filters.lotacao"
              outlined
              dense
            />
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              id="funcao"
              label="Função"
              :items="form.lists.listFuncoes"
              :item-text="'nome'"
              :item-value="'id'"
              v-model="form.filters.funcao"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarSolicitacoesDeAcesso()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="headers"
        :items="form.lists.listSolicitacoesDeAcesso"
        :items-per-page="10"
        :footer-props="$footerProps"
        no-data-text="Não há registros a serem exibidos"
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:[`item.cpf`]="{ item }">
          {{ item.cpf }}
        </template>
        <template v-slot:[`item.lotacao`]="{ item }">
          {{ item.lotacao }}
        </template>
        <template v-slot:[`item.funcao`]="{ item }">
          {{ item.funcao }}
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          {{ item.situacao }}
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            v-if="item.situacao != 'Pendente de aprovação'"
            :icon="'mdi-pencil'"
            :text="'Editar parecer'"
            :small="true"
            :color="'primary'"
            @click="openDialogManterSolicitacoesDeAcesso(item, false)"
          ></sca-tooltip>
          <sca-tooltip
            v-if="item.situacao == 'Pendente de aprovação'"
            :icon="'mdi-file-find'"
            :text="'Realizar parecer'"
            :small="true"
            :color="'green'"
            @click="openDialogManterSolicitacoesDeAcesso(item, true)"
          ></sca-tooltip>
          <sca-tooltip
            v-if="item.situacao != 'Pendente de aprovação'"
            :text="'Visualizar parecer '"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarSolicitacoesDeAcesso(item)"
          ></sca-tooltip>
          <sca-tooltip
            v-if="item.situacao != 'Pendente de aprovação'"
            :text="'Enviar e-mail'"
            :icon="'mdi-email'"
            :small="true"
            @click="enviarEmailSolicitacoesDeAcesso(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarSolicitacaoAcessoDialog
      :visible="dialogManterSolicitacoesDeAcesso.visible"
      :content="dialogManterSolicitacoesDeAcesso.content"
      :edit="dialogManterSolicitacoesDeAcesso.edit"
      @onClose="dialogManterSolicitacoesDeAcesso.close()"
      @onSave="buscarSolicitacoesDeAcesso()"
      :primeiroEnvio="primeiroEnvio"
    ></CadastrarEditarSolicitacaoAcessoDialog>
    <VisualizarSolicitacaoAcessoDialog
      :visible="dialogVisualizarSolicitacoesDeAcesso.visible"
      :content="dialogVisualizarSolicitacoesDeAcesso.content"
      @onClose="dialogVisualizarSolicitacoesDeAcesso.close()"
    ></VisualizarSolicitacaoAcessoDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { SolicitacaoAcesso } from '~/commons/classes/solicitacao-acesso';
import SolicitacoesDeAcessoService from '~/services/solicitacoes-acesso.service';
import CadastrarEditarSolicitacaoAcessoDialog from "./dialogs/CadastrarEditarSolicitacaoAcessoDialog.vue";
import VisualizarSolicitacaoAcessoDialog from "./dialogs/VisualizarSolicitacaoAcessoDialog.vue";
import UtilMixin from '~/mixins/util.mixin';
import PreLoginService from "~/services/pre-login.service";

export default {
  name: "ManterSolicitacaoAcessoView",
  mixins: [SolicitacoesDeAcessoService, UtilMixin, PreLoginService],
  components: {
    CadastrarEditarSolicitacaoAcessoDialog,
    VisualizarSolicitacaoAcessoDialog,
  },
  data: () => ({
    dialogManterSolicitacoesDeAcesso: Dialog.Build(),
    dialogVisualizarSolicitacoesDeAcesso: Dialog.Build(),
    primeiroEnvio: false,
    form: {
      filters: {
        nome: null,
        cpf: null,
        lotacao: null,
        funcao: null,
        situacao: null,
      },
      lists: {
        listSolicitacoesDeAcesso: [],
        listFuncoes: [],
        listLotacao: [],
        listSituacoes: [],
      }
    },
    headers: [
      { text: "Nome", align: "center", value: "nome" },
      { text: "CPF", align: "center", value: "cpf", sortable: false },
      { text: "Lotação", align: "center", value: "lotacao" },
      { text: "Função", align: "center", value: "funcao" },
      { text: "Situação", align: "center", value: "situacao", sortable: false },
      { text: "Ações", align: "center", value: "acoes", sortable: false },
    ]
  }),
  computed: {
    textoDaSolicitacaoDeAcesso() {
      return this.$textoDaSolicitacaoDeAcesso();
    }
  },
  methods: {
    openDialogManterSolicitacoesDeAcesso(solicitacoesDeAcesso, primeiraSolicitacaoDeAcesso) {
      this.primeiroEnvio = primeiraSolicitacaoDeAcesso;
      solicitacoesDeAcesso
        ? this.$visualizarSolicitacoesDeAcesso(solicitacoesDeAcesso).then(({ data }) => this.dialogManterSolicitacoesDeAcesso.open(new SolicitacaoAcesso(data.resposta), true))
        : this.dialogManterSolicitacoesDeAcesso.open(SolicitacaoAcesso.Build());
    },

    openDialogVisualizarSolicitacoesDeAcesso(solicitacoesDeAcesso) {
      this.$visualizarSolicitacoesDeAcesso(solicitacoesDeAcesso).then(({ data }) =>
      (this.dialogVisualizarSolicitacoesDeAcesso.open(data.resposta)));
    },

    buscarSolicitacoesDeAcesso() {
      const userRoles = this.$user?.roles.map(role => role.toUpperCase()) || [];
      const originalCpf = this.form.filters.cpf;

      if (this.form.filters.cpf) {
        this.form.filters.cpf = this.form.filters.cpf.replace(/[^\d]/g, '');
      }

      const roleMethodMap = {
        'ADMINISTRADOR': this.$buscarSolicitacoesDeAcessoADM,
        'GGEIAI': this.$buscarSolicitacoesDeAcessoGGEIAI,
        'ARTICULADOR REGIONAL': this.$buscarSolicitacoesDeAcessoArticuladorRegional
      };

      const userRole = ['ADMINISTRADOR', 'GGEIAI', 'ARTICULADOR REGIONAL'].find(role => userRoles.includes(role));
      const buscarSolicitacoes = roleMethodMap[userRole];

      if (buscarSolicitacoes) {
        buscarSolicitacoes({ params: this.form.filters }).then(({ data }) => {
          this.form.lists.listSolicitacoesDeAcesso = data.itens;
          this.form.filters.cpf = originalCpf;
        });
      }else {
        this.$notifyError('Você não tem permissão para realizar essa ação!');
      }
    },

    enviarEmailSolicitacoesDeAcesso(solicitacoesDeAcesso) {
      this.$swal({
        text: `Deseja enviar um e-mail de confirmação para o profissional?`,
        type: "question",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        const payloadEmail = {
            id: solicitacoesDeAcesso.id,
            primeiroEnvio: this.primeiroEnvio,
          };
        this.$envioDeEmailSolicitacoesDeAcesso(payloadEmail, solicitacoesDeAcesso.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
        });
      });
    },
    resetForm() {
      this.$resetForm();
      this.form.lists.listSolicitacoesDeAcesso = [];
      this.form.filters.situacao = null;
    }
  },
  mounted() {
    this.$obterFuncoes().then(({ data }) => {
      this.form.lists.listFuncoes = data.lista;
    });
    this.$obterLotacoes().then(({ data }) => {
      this.form.lists.listLotacao = data.lista;
    });
    this.$buscarSituacoesSolicitacoesDeAcesso({ params: { atribuiveis: false } }).then(({ data }) => {
      this.form.lists.listSituacoes = data.itens;
    });
  }
};
</script>
